<div
  class="support-type-details"
  [class.last-minute-job]="isLastMinuteJob"
  *ngIf="budgetSupportTypes?.length"
>
  <span class="screen-reader-only">Rate service categories</span>
  <ion-icon
    class="ion-margin-end"
    name="list"
  ></ion-icon>
  <div>
    <p
      class="ion-no-margin"
      *ngFor="let supportType of budgetSupportTypes; let last = last"
    >
      <span class="semi-bold">{{ supportType.name }}</span> ({{ supportType.displayName }})
      <!-- only add comma if element is not the last one -->
      <span *ngIf="!last">,</span>
    </p>
  </div>
</div>
